import { Icon } from "@chakra-ui/react";

const IsraelIcon = () => {
  return (
    <>
     <Icon width="7" height="5" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_5_78" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="18">
          <path d="M0 0H24V17.9999H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_5_78)">
          <path fillRule="evenodd" clipRule="evenodd" d="M24.8571 17.9999H-0.857101V0H24.8571V17.9999Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M24.8571 4.05106H-0.857101V1.68762H24.8571V4.05106ZM24.8571 16.3715H-0.857101V14.0081H24.8571V16.3715ZM7.87672 6.7071L11.7481 13.4409L15.7028 6.73488L7.87672 6.7071Z" fill="#0000CC" />
          <path fillRule="evenodd" clipRule="evenodd" d="M11.0169 11.173L11.7534 12.4212L12.5057 11.1781L11.0169 11.173V11.173Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M7.8623 11.2704L11.734 4.53656L15.6884 11.2426L7.8623 11.2704Z" fill="#0000CC" />
          <path fillRule="evenodd" clipRule="evenodd" d="M11.0169 6.73623L11.7534 5.48798L12.5057 6.7311L11.0169 6.73619V6.73623ZM9.47773 9.53114L8.71695 10.7961L10.1548 10.7917L9.47773 9.53114ZM8.72996 7.19326L10.1793 7.20345L9.48198 8.47821L8.72999 7.19326H8.72996ZM14.047 9.54555L14.7793 10.7963L13.3129 10.7775L14.047 9.54555ZM14.7659 7.19326L13.3166 7.20345L14.0139 8.47821L14.7659 7.19326ZM10.7486 7.19185L9.7504 9.00292L10.7629 10.7712L12.6167 10.8139L13.7432 9.00288L12.7022 7.17758L10.7485 7.19182L10.7486 7.19185Z" fill="white" />
        </g>
      </Icon>
    </>
  );
};

export default IsraelIcon;
